const messages = {

    es: {
        translations: {

            navbar: {
                privateContact: 'CONTACTO PRIVADO',
                home: 'Home',
                about: 'Sobre',
                skills: 'Habilidades',
                projects: 'Proyectos',
                contact: 'Contacto'
            },

            initial: {
                wellcome: 'Bienvenido, soy',
                h1: 'Gabriel Gonçalves Cunha',
                h2: 'Developer',
                em: 'front end.',
                p: 'Creación de interfaces eficientes y optimizadas'
            },

            presentation: {
                about: 'SOBRE',
                about_text1: 'Estoy dispuesto a hacer que lo que está en mis manos funcione lo mejor que pueda.',
                address: 'VIVE EN',
                address_text1: 'São Paulo',
                address_text2: 'São Paulo',
                address_text3: 'Brasil',
                experience: 'EXPERIENCIA',
                experience_text: '2 - 5 años | Pleno (mid)',
                download: 'DOWNLOAD',
                download_button: 'Profile.pdf'
            },

            skills: {
                focus: 'Enfoque y habilidades',
                p: 'Mi enfoque es entregar resultados. Mis principales áreas de especialización incluyen: Desarrollo de sitios web responsivos y rápidos con diseño profesional. Creación de e-commerce optimizados para la conversión. Desarrollo de landing pages estratégicas para campañas y lanzamientos. Optimización de SEO para aumentar la visibilidad en Google. Mantenimiento especializado de sitios web y soporte técnico.',

                development_desc: 'Desarrollo de aplicaciones modernas y rápidas, utilizando componentes reutilizables para garantizar la escalabilidad.',
                design_desc: 'Creación de interfaces intuitivas y profesionales, enfocadas en la experiencia del usuario y en la fidelidad visual.',
                marketing_desc: 'Optimización para Google (SEO) e infraestructura en la nube para garantizar que el sitio soporte el tráfico y cargue instantáneamente.',
                workflow_desc: 'Uso de flujos de trabajo organizados y control de versiones para garantizar la seguridad del código y entregas constantes.',
                text_dev:'En estos proyectos, fui responsable del desarrollo frontend de más de 45 tiendas, trabajando junto con el equipo ',
            },

            projects: {
                project: 'PROYECTOS',
                development: 'Desarrollos y participaciones',
                seemore: 'Ver más',
                modal_button: 'Cerrar',
                modal_warning: 'Es posible que el sitio no esté disponible debido a la administración del cliente. Actualizado el 2022-07-04*'
            },

            contact: {
                send: 'Enviar un correo electrónico a',
                follow: 'SEGUIR'
            }
        }
    }
}

export { messages }

//   {i18n.t('quote.info')}
//   import { i18n } from "../../translate/i18n";